// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { DispositiveProvisions_DispositiveProvisionFragment } from '../../../graphql/DispositiveProvisions.fragments.generated';
import { gql } from '@apollo/client';
import { DispositiveProvisions_DispositiveProvisionFragmentDoc } from '../../../graphql/DispositiveProvisions.fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DispositiveProvisionTemplates_DispositiveProvisionTemplateFragment = { __typename?: 'DispositiveProvisionTemplate', id: string, displayName: string, residuaryPaysAllTaxes: boolean, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', edges?: Array<{ __typename?: 'DispositiveProvisionEdge', node?: (
        { __typename?: 'DispositiveProvision' }
        & DispositiveProvisions_DispositiveProvisionFragment
      ) | null } | null> | null } };

export type DispositiveProvisionTemplatesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.DispositiveProvisionTemplateWhereInput>;
}>;


export type DispositiveProvisionTemplatesQuery = { __typename?: 'Query', dispositiveProvisionTemplates: { __typename?: 'DispositiveProvisionTemplateConnection', edges?: Array<{ __typename?: 'DispositiveProvisionTemplateEdge', node?: (
        { __typename?: 'DispositiveProvisionTemplate' }
        & DispositiveProvisionTemplates_DispositiveProvisionTemplateFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    DispositiveProvisionTemplates: 'DispositiveProvisionTemplates' as const
  },
  Fragment: {
    DispositiveProvisionTemplates_DispositiveProvisionTemplate: 'DispositiveProvisionTemplates_DispositiveProvisionTemplate' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const DispositiveProvisionTemplates_DispositiveProvisionTemplateFragmentDoc = gql`
    fragment DispositiveProvisionTemplates_DispositiveProvisionTemplate on DispositiveProvisionTemplate {
  id
  displayName
  residuaryPaysAllTaxes
  dispositiveProvisions {
    edges {
      node {
        ...DispositiveProvisions_DispositiveProvision
      }
    }
  }
}
    ${DispositiveProvisions_DispositiveProvisionFragmentDoc}`;
export const DispositiveProvisionTemplatesDocument = gql`
    query DispositiveProvisionTemplates($where: DispositiveProvisionTemplateWhereInput) {
  dispositiveProvisionTemplates(where: $where) {
    edges {
      node {
        ...DispositiveProvisionTemplates_DispositiveProvisionTemplate
      }
    }
  }
}
    ${DispositiveProvisionTemplates_DispositiveProvisionTemplateFragmentDoc}`;

/**
 * __useDispositiveProvisionTemplatesQuery__
 *
 * To run a query within a React component, call `useDispositiveProvisionTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispositiveProvisionTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispositiveProvisionTemplatesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDispositiveProvisionTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<DispositiveProvisionTemplatesQuery, DispositiveProvisionTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DispositiveProvisionTemplatesQuery, DispositiveProvisionTemplatesQueryVariables>(DispositiveProvisionTemplatesDocument, withFetchPolicyContext(options));
      }
export function useDispositiveProvisionTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DispositiveProvisionTemplatesQuery, DispositiveProvisionTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DispositiveProvisionTemplatesQuery, DispositiveProvisionTemplatesQueryVariables>(DispositiveProvisionTemplatesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDispositiveProvisionTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DispositiveProvisionTemplatesQuery, DispositiveProvisionTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DispositiveProvisionTemplatesQuery, DispositiveProvisionTemplatesQueryVariables>(DispositiveProvisionTemplatesDocument, withFetchPolicyContext(options));
        }
export type DispositiveProvisionTemplatesQueryHookResult = ReturnType<typeof useDispositiveProvisionTemplatesQuery>;
export type DispositiveProvisionTemplatesLazyQueryHookResult = ReturnType<typeof useDispositiveProvisionTemplatesLazyQuery>;
export type DispositiveProvisionTemplatesSuspenseQueryHookResult = ReturnType<typeof useDispositiveProvisionTemplatesSuspenseQuery>;
export type DispositiveProvisionTemplatesQueryResult = Apollo.QueryResult<DispositiveProvisionTemplatesQuery, DispositiveProvisionTemplatesQueryVariables>;